import { defineComponent as _defineComponent } from 'vue'
import { switchProps, switchEmits } from './switch';
import { UPDATE_MODEL_VALUE } from '../../constants';
import createComponentId from '../../utils/createComponentId';


export default /*#__PURE__*/_defineComponent({
  __name: 'switch',
  props: switchProps,
  emits: switchEmits,
  setup(__props, { emit: emits }) {

const props = __props




const inputId = createComponentId('ui-switch');

const handleChange = (event): void => {
    const isChecked = (event.target as HTMLInputElement).checked;
    emits(UPDATE_MODEL_VALUE, isChecked);
    emits('change', isChecked);
};

const handleSpaceKey = (): void => {
    if (props.disabled) {
        return;
    }

    const newValue = !props.modelValue;
    emits(UPDATE_MODEL_VALUE, newValue);
    emits('change', newValue);
};

return { __sfc: true,props, emits, inputId, handleChange, handleSpaceKey }
}

})